<template>
  <div class>
    <div class="header fColor1">
      <p class="fl">
        {{$t('NEW.s18')}}：
        <span class="asset_name">$</span>
        <span class="asset_num">{{zongzichan | toFixeds4}}</span>
      </p>
      <!-- <p class="fr right_text">
        <span class="address" @click="withdraw_address">{{$t('asset.address_bind')}}</span>
      </p> -->
    </div>
    <div class="content fColor1 ft12">
      <div class="content_top flex alcenter fColor2">
        <p class="flex1 tc">
          {{$t('asset.currency')}}
          <i></i>
        </p>
        <p class="flex1 tc">{{$t('asset.canuse')}}</p>
        <p class="flex1 tc">{{$t('asset.frezz')}}</p>
        <p class="flex1 tc">{{$t('NEW.s18')}}($)</p>
        <p class="flex1 tc">{{$t('td.do')}}</p>
      </div>
      <ul class="content_ul" v-if="pirce!==null">
        <li>
          <div class="content_li bdb flex alcenter between">
            <p class="flex1 tc">USDT</p>
            <p class="flex1 tc">
              <!-- <span v-if="item.currency_name=='BTC'||item.currency_name=='ETH'">{{item.change_balance || '0.00' | toFixeds8}}</span> -->
              <span>{{pirce.usdt_balance || '0.00' | toFixeds4}}</span>
            </p>
            <p class="flex1 tc">
              <!-- <span v-if="item.currency_name=='BTC'||item.currency_name=='ETH'">{{item.lock_change_balance || '0.00' | toFixeds4}}</span> -->
              <span>{{pirce.total_lock_usdt || '0.00' | toFixeds4}}</span>
            </p>
            <p class="flex1 tc">
              <!-- <span v-if="item.currency_name=='BTC'||item.currency_name=='ETH'">{{item.cny_price * item.change_balance || '0.00' | toFixeds4}}</span> -->
              <!-- <span>{{item.usdt_price * item.change_balance || '0.00' | toFixeds4}}</span> -->
              <span>{{Number(pirce.usdt_balance) + Number(pirce.total_lock_usdt)  || '0.00' | toFixeds4}}</span>
            </p>
            <p class="flex1 tc operation">
              <!-- <span
                @click="excharge(index,item.currency,item.currency_type,item.contract_address,1)"
              >{{$t('NEW.s15')}}</span> -->
               <!-- <span
               
              >{{$t('NEW.s15')}}</span> -->
              <!-- <span
                @click="withdraw(index,item.currency,item.currency_name,item.contract_address,item.is_show_memo,2)"
                style="padding: 0 5px;"
              ></span> -->
              <span @click="showLicai(1)">{{$t('NEW.s16')}}</span>
              <span @click="$router.push({path:'/transferLegal1'})">{{$t('NEW.s17')}}</span>
            </p>
          </div>
          <!--记录区-->
          <div class="hide_div bd rec-box fColor1" v-if="TABINDEX == 1">
            <div class="rec-con">
              <div class="rec-title bdb fColor1">
                <span>{{$t('td.num')}}</span>
                <span>{{$t('asset.record')}}</span>
                <span>{{$t('NEW.s26')}}</span>
              </div>
              <ul class="rec-list">
                <li v-for="(items,index) in jilu" :key="index" class="bdb">
                  <span>{{items.usdt_amount}}</span>
                  <span>{{$t('NEW.s22')}}</span>
                   <span>{{items.end_at}}</span>
                </li>
              </ul>
              <p class="more"  @click="moreData()" v-if="hasmore">{{more}}</p>
            </div>
          </div>
        </li>
        <li>
          <div class="content_li bdb flex alcenter between">
            <p class="flex1 tc">AUTU</p>
            <p class="flex1 tc">
              <!-- <span v-if="item.currency_name=='BTC'||item.currency_name=='ETH'">{{item.change_balance || '0.00' | toFixeds4}}</span> -->
              <span>{{pirce.df_balance || '0.00' | toFixeds4}}</span>
            </p>
            <p class="flex1 tc">
              <!-- <span v-if="item.currency_name=='BTC'||item.currency_name=='ETH'">{{item.lock_change_balance || '0.00' | toFixeds4}}</span> -->
              <span>{{pirce.total_lock_df || '0.00' | toFixeds4}}</span>
            </p>
            <p class="flex1 tc">
              <!-- <span v-if="item.currency_name=='BTC'||item.currency_name=='ETH'">{{item.cny_price * item.change_balance || '0.00' | toFixeds4}}</span> -->
              <!-- <span>{{item.usdt_price * item.change_balance || '0.00' | toFixeds4}}</span> -->
              <span>{{Number(pirce.df_balance) + Number(pirce.total_lock_df)  || '0.00' | toFixeds4}}</span>
            </p>
            <p class="flex1 tc operation">
              <!-- <span
                @click="excharge(index,item.currency,item.currency_type,item.contract_address,1)"
              >{{$t('NEW.s15')}}</span> -->
               <!-- <span
               
              >{{$t('NEW.s15')}}</span> -->
              <!-- <span
                @click="withdraw(index,item.currency,item.currency_name,item.contract_address,item.is_show_memo,2)"
                style="padding: 0 5px;"
              ></span> -->
              <span @click="SHOW()">{{$t('NEW.s15')}}</span>
              <span @click="showLicai(2)">{{$t('NEW.s16')}}</span>
              <span @click="$router.push({path:'/transferLegal1'})">{{$t('NEW.s17')}}</span>
            </p>
          </div>
          <!--记录区-->
          <div class="hide_div bd rec-box fColor1" v-if="TABINDEX == 2">
            <div class="rec-con">
              <div class="rec-title bdb fColor1">
                <span>{{$t('td.num')}}</span>
                <span>{{$t('asset.record')}}</span>
                <span>{{$t('NEW.s26')}}</span>
              </div>
              <ul class="rec-list">
                <li v-for="(items,index) in jilu" :key="index" class="bdb">
                  <span>{{items.amount}}</span>
                  <span>{{$t('NEW.s22')}}</span>
                   <span>{{items.end_at}}</span>
                </li>
              </ul>
              <p class="more" @click="moreData()"  v-if="hasmore">{{more}}</p>
            </div>
          </div>
        </li>
      </ul>
      <!-- <div class="tc ft16 fColor1 mt50" v-show="asset_list.length<=0">暂无数据</div> -->
    </div>
    <div class="jiedong" v-if="isShow == true">
        <h1>{{$t('NEW.s27')}}{{usdtNum}}USDT </br>{{$t('NEW.s28')}}{{autuNum}}{{$t('NEW.s29')}}AUTU{{$t('NEW.s30')}}？</h1>
        <div class="btn">
            <div style="background-color:#5697f4" @click="jiedong(1)">{{$t('NEW.s24')}}</div>
            <div style="background-color:#eee" @click="jiedong(2)">{{$t('NEW.s25')}}</div>
        </div>
    </div>
  </div>
</template>
<script>
import indexHeader from "@/view/indexHeader";
import left from "@/view/left";
import "@/lib/clipboard.min.js";
import "@/lib/jquery.qrcode.min.js";
export default {
  name: "finance",
  filters: {
    toFixeds: function(value) {
      value = Number(value);
      return value.toFixed(8);
    },
    toFixeds8: function(value) {
      value = Number(value);
      return value.toFixed(8);
    },
    toFixeds4: function(value) {
      value = Number(value);
      return value.toFixed(4);
    }
  },
  data() {
    return {
      lang:localStorage.getItem("locale") || "en",
      totle: "",
      recData: [],
      token: "",
      flags: false,
      flag: false,
      isHide: true,
      active: "a",
      active01: "a",
      active02: "a",
      addr: "",
      url: "",
      excharge_address: "",
      address: "",
      number: "",
      rate: "",
      coinname: "",
      balance: "",
      ratenum: "",
      reachnum: "",
      min_number: "",
      currency: "",
      password: "",
      asset_list: [],
      tip_list: [this.$t("asset.tips01"), this.$t("asset.tips02")],
      tip_list01: [this.$t("asset.tips01"), this.$t("asset.tips02")],
      page: 1,
      more: this.$t("td.more"),
      balanceList: [
        this.$t("asset.fince_account"),
        this.$t("asset.lever_account")
      ],
      transferData: {
        modalShow: false,
        transferName: "",
        transferBalance: "",
        start: "",
        end: ""
      },
      status: "",
      ishowTag: false,
      extension_code: "", //地址标签
      taginput: "",
      is_show_memo: 0,
      chargeType: [],
      contractAddress: "",
      userId: "",
      currencyName: "",
      selectType: 1,
      name: "",
      labelText: "",
      walletData: [],
      labels:'',
      zongzichan:null,
      pirce:null,
      TABINDEX:null,
      jilu:[],
      isShow:false,
      pageNum:1,
      hasmore:true,
      usdtNum:null,
      autuNum:null,
    };
  },
  components: {
    indexHeader,
    left
  },
  methods: {
      showLicai(index){
          if(index!==this.TABINDEX){
              this.pageNum = 1;
              this.getorder(1);
          }
          if(index == this.TABINDEX){
              this.TABINDEX = 0
          }else{
              this.TABINDEX = index
          }
          console.log(this.TABINDEX)
      },
    goRecord() {
      this.$router.push({ name: "coinRecord" });
    },
    init() {
      var that = this;
      var clipboard = new Clipboard(".copy");
      clipboard.on("success", function(e) {
        layer.alert(that.$t("set.copysuccess"));
      });
      clipboard.on("error", function(e) {
        alert(that.$t("set.copyfail"));
      });
    },
    SHOW(){
        this.isShow= true
    },
    // 解冻
    jiedong(type){
        var that = this
        that.isShow = false;
        if(type == 1){
            this.$http({
        url: "/api/bank/deposit",
        method:'post',
        data:{
            num:1
        },
        headers: { Authorization: this.token },
        // headers: { Authorization: that.token }
        })
        .then(res => {
                layer.msg(res.data.message)
                if(res.data.type == 'ok'){
                    // console.log(this.coinIndex,this.coins[this.coinIndex]);
                    setTimeout(() => {
                       that.getorder(1);
                       that.TABINDEX=1
                    },2000)
                }
        })
        .catch(error => {
          console.log(error);
        });
        }
    },
    // 获取资产
    getPrice(){
        var that = this
        this.$http({
        url: "/api/bank/my_account",
        method:'get',
        headers: { Authorization: this.token },
        // headers: { Authorization: that.token }
      })
        .then(res => {
            let data = res.data.message.account_info
            that.usdtNum = res.data.message.usdt
            that.autuNum = res.data.message.df
            that.pirce = data
            that.zongzichan = Number(data.usdt_balance)+Number(data.total_lock_usdt)+Number(data.total_lock_df)+Number(data.df_balance);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getorder(page){
        var that = this
        that.$http({
        url: "/api/bank/deposit_order?limit=10&page="+page,
        method:'get',
        headers: { Authorization: that.token },
        data:{
            page:page,
            limit:10
        }
        // headers: { Authorization: that.token }
      })
        .then(res => {
            var arr = that.jilu;
            console.log(res.data.message.order_list)
            arr.push(res.data.message.order_list)
            if(res.data.message.order_list.length<10){
                that.hasmore = false
            }
            that.jilu = res.data.message.order_list;

        })
        .catch(error => {
          console.log(error);
        });
    },
    sendData(currency, addr) {
      var that = this;
      $("#code").html("");
      this.$http({
        url: this.API + "/api/wallet/get_in_address",
        method:'post',
        headers: { Authorization: this.token },
        data: {
          currency: currency,
          user_id: localStorage.getItem("user_id"),
        }
        // headers: { Authorization: that.token }
      })
        .then(res => {
          
            $("#code").html('');
          if (res.data.type == 'ok') {
            if(res.data.message.omni){
                that.excharge_address=res.data.message.omni;
              // 生成二维码
              $("#code").qrcode({
                width: 100, //宽度
                height: 100, //高度
                text: res.data.message.omni
              });
            }else{
                that.excharge_address=res.data.message;
                $("#code").qrcode({
                width: 100, //宽度
                height: 100, //高度
                text: res.data.message
              });
            } 
          } else {
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //记录
    rec(index, currency) {
      this.currency = currency;
      this.recData = [];
      if (this.flag) {
        this.flag = false;
        this.active = "a";
        this.active01 = "a";
        this.active02 = "a";
      } else {
        this.flag = true;
        this.active02 = index;
        this.active = "a";
        this.active01 = "a";
        this.$http({
          url: "/api/wallet/legal_log",
          method: "post",
          data: { type: 2, currency: currency, page: 1 },
          headers: { Authorization: this.token }
        }).then(res => {
          if (res.data.type == "ok") {
            this.recData = res.data.message.list;
          }
        });
      }
    },
    copy2(e) {
      var that = this;
      var clipboard = new Clipboard(".copy2", {
        text: function() {
          return that.labelText;
        }
      });
      clipboard.on("success", function(e) {
        that.flags = true;
        layer.msg(that.$t("set.copysuccess"));
      });
      clipboard.on("error", function(e) {
        that.flags = false;
        layer.msg(that.$t("set.recopy"));
      });
    },
    record() {
      this.$router.push({ name: "finanrec" });
    },
    withdraw_address() {
      this.$router.push({ name: "withdraw_address" });
    },
    show_ewm() {
      if (this.isHide) {
        this.isHide = false;
      } else {
        this.isHide = true;
      }
    },
    getdata() {
      var that = this;
      this.$http({
        url: "/api/" + "wallet/list",
        method: "post",
        data: {},
        headers: { Authorization: that.token }
      })
        .then(res => {
          if (res.data.type == "ok") {
            that.asset_list = res.data.message.change_wallet.balance;
            that.totle = res.data.message.change_wallet.usdt_totle;
            that.status = res.data.message.is_open_CTbi;
          } else {
            return;
          }
          // this.asset_list.forEach((item, index) => {
          //   this.$http({
          //     url: "/api/wallet/legal_log",
          //     method: "post",
          //     data: { type: "0", currency: item.currency, page: this.page },
          //     headers: { Authorization: this.token }
          //   }).then(res => {
          //     if (res.data.type == "ok") {
          //       this.recData[index] = res.data.message.list;
          //     }
          //   });
          // });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 加载更多
    moreData() {
     this.pageNum+=1;
     this.getorder(this.pageNum);
    },
    // 划转
    transfer(index, currency) {
      let that = this;
      that.transferData.modalShow = true;
    },
    // getAddress(name, addr) {
    //   var that = this;
    //   that.address = "";
    //    this.$http({
    //     url: this.API + "/api/wallet/get_in_address",
    //     method: "post",
    //     data: {
    //       user_id: localStorage.getItem("user_id"),
    //       currency: that.currency,
    //     }
    //   }).then(res => {
    //     if (res.data.type == 'ok') {
    //       if(res.data.message.omni){
    //           that.address=res.data.message.omni;
    //       }else{
    //           that.address=res.data.message;
    //       }          
    //     } else {
    //       that.address = "";
    //       // layer.msg(res.data.errorinfo)
    //       if (res.data.errorinfo == "请先设置提币地址") {
    //         var lang = localStorage.getItem("locale");
    //         if (lang == "jp") {
    //           layer.msg("まずトークンの住所を設定してください");
    //         } else if (lang == "en") {
    //           layer.msg("Please set the withdrawal address first");
    //         } else if (lang == "hk") {
    //           layer.msg("請先設定提幣地址");
    //         } else {
    //           layer.msg(res.data.errorinfo);
    //         }
    //       }
    //     }
    //   });
    //   // this.$http({
    //   //   url: this.API + "/wallet/get_in_address",
    //   //   method: "GET",
    //   //   params: {
    //   //     user_id: localStorage.getItem("user_id"),
    //   //     currency: name,
    //   //     contract_address: addr
    //   //   }
    //   // }).then(res => {
    //   //   if (res.data.code == 0) {
    //   //     that.address = res.data.data.address;
    //   //   } else {
    //   //     that.address = "";
    //   //     // layer.msg(res.data.errorinfo)
    //   //     if (res.data.errorinfo == "请先设置提币地址") {
    //   //       var lang = localStorage.getItem("locale");
    //   //       if (lang == "jp") {
    //   //         layer.msg("まずトークンの住所を設定してください");
    //   //       } else if (lang == "en") {
    //   //         layer.msg("Please set the withdrawal address first");
    //   //       } else if (lang == "hk") {
    //   //         layer.msg("請先設定提幣地址");
    //   //       } else {
    //   //         layer.msg(res.data.errorinfo);
    //   //       }
    //   //     }
    //   //   }
    //   // });
    // }
  },
  created() {
    this.token = localStorage.getItem("token") || "";
  },
  mounted() {
    var that = this;
    that.getdata();
    that.getPrice();
    that.getorder(1)
    this.init();
  }
};
</script>
<style scoped lang="scss">
.jiedong{
    width: 300px;
    height: 150px;
    border-radius: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    transform: translateY(-50%);
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    h1{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        text-align: center;
    }
    .btn{
        display: flex;
        justify-content: space-around;
        div{
            margin-top: 25px;
            padding: 10px 20px;
            height: 40px;
            min-width: 100px;
            text-align: center;
            border-radius: 15px;
            background-color: red;
            cursor: pointer;
        }
    }
}
.header {
  padding: 15px 30px;
  overflow: hidden;
}
.min_lab {
  margin: 0 10px;
}
.min_lab input {
  margin-right: 3px;
}
.inp_lab {
  border: 1px solid #6b80ae;
  border-radius: 2px;
  padding: 3px 5px;
}
.inp_lab input {
  background: none;
  border: none;
  width: 120px;
  color: #fff;
}
.right_text {
  color: #5697f4;
}
.right_text span {
  cursor: pointer;
}
.record {
  margin-right: 10px;
}
.content_ul {
  padding: 0 20px;
}
.content_top {
  padding: 10px 20px;
  // background: #161617c7;
}
.content_li {
  padding: 15px 0;
  // border-bottom: 1px solid #1e2c42;
}
.operation,
.copy,
.ewm {
  color: #5697f4;
}
.copy {
  margin: 0 30px;
}
.copy:hover {
  cursor: pointer;
}
.ewm:hover {
  cursor: pointer;
}
.operation span {
  cursor: pointer;
}
.hide_div {
  // border: 1px solid #1e2c42;
  padding: 20px;
}
.excharge_record {
  color: #5697f4;
}
input {
  background: none;
  border: none;
}
.address_inp {
  width: 100%;
  border: 1px solid #6b80ae;
  border-radius: 3px;
  padding: 15px 15px;
}
.num_lab {
  display: flex;
  width: 100%;
  border: 1px solid #6b80ae;
  border-radius: 3px;
  padding: 15px;
}
.num_lab input {
  width: 100%;
}
.range_lab,
.get_lab {
  border: 1px solid #6b80ae;
  border-radius: 3px;
  padding: 15px;
}
.get_lab {
  // background: #1e2c42;
}
.right_inp_wrap {
  margin-left: 20px;
}
.use_num,
.advance {
  color: #5697f4;
}
.use_num {
  margin-right: 5px;
}
.advance {
  margin-left: 5px;
}
.withdraw_btn {
  background-color: #7a98f7;
  color: #fff;
  padding: 15px 20px;
  min-width: 160px;
  border: none;
  border-radius: 5px;
}
.withdraw_btn:hover {
  cursor: pointer;
}
.bg {
  background: #2b3c71;
}
.ewm_wrap {
  position: relative;
}
.ewm_img {
  width: 120px;
  height: 120px;
  position: absolute;
  top: 25px;
  left: -30px;
  border: 10px solid #fff;
}
.hide {
  display: none;
}
.rec-box {
  .rec-con {
    margin: 10px;
    padding: 0 20px;
    // background: #171c2b;
    span {
      flex: 1;
      text-align: center;
      line-height: 3;
    }
    .rec-title {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      line-height: 1.5;
    }
    li {
      display: flex;

      justify-content: space-between;
      font-size: 12px;
      color: #728daf;
      // border-top: 1px solid #2e394c;
    }
  }
}
.more {
  width: 100%;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
// 划转弹窗
.transfer-modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  justify-content: center;
  align-items: center;
}
.transfer-mask {
  width: 500px;
  background-color: #171c2b;
  margin: 0 auto;
  border-radius: 5px;
}
.transfer-header {
  line-height: 40px;
  text-align: center;
  position: relative;
}
.transfer-header p {
  position: absolute;
  right: 10px;
  top: 0;
}
.pb10 {
  padding: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
</style>





// WEBPACK FOOTER //
// src/view/accounts/conductFinancial.vue